export default {
  GET_THE_APP: 'Obtenha o Aplicativo',
  MAKE_FLOCK_BETTER_APPS: 'Deixe o Flock ainda melhor com aplicativos',
  URL_APP_DECORATOR_NO_PROMPT_TEXT:
    'Ok, n\u00e3o enviaremos sugest\u00f5es de aplicativos para {appOrDomain}.\nVisite a {flockStore} para descobrir mais aplicativos.',
  FLOCK_APP_STORE: 'Flock App Store',
};
